import { NgModule } from '@angular/core';
import { LaneButtonsComponent } from './lane-buttons.component';
import { CommonModule } from '@angular/common';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { TooltipModule } from '../tooltip/tooltip.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    TranslateModule.forChild(),
    CommonModule,
    SvgIconModule,
    TooltipModule
  ],
  declarations: [
    LaneButtonsComponent
  ],
  exports: [
    LaneButtonsComponent
  ]
})
export class LaneButtonsModule {}
